<template>
	<page>
		<module>
			<view-list work-type="35" ref="view" selector :view-config="auth('b_outsourcing_process_viewmanage')">
				<template #search>
					<m-search ref="search">
                        <m-search-item label="动态类型">
                            <c-select name="progress_type" :options="outSourcingOrderProcessName"></c-select>
                        </m-search-item>
                        <m-search-item label="委外单号">
                            <c-input name="outsourcing_code"></c-input>
                        </m-search-item>
                        <m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="工序">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item label="供应商">
							<c-select name="supplier_ids" async multiple @search="searchSupplier" ></c-select>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_outsourcing_process_export')" v-lock="lock('b_outsourcing_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_outsourcing_process_export')" v-lock="lock('b_outsourcing_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_outsourcing_process_export')" v-lock="lock('b_outsourcing_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_outsourcing_process_export')" v-lock="lock('b_outsourcing_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_outsourcing_process_print')" v-lock="lock('b_outsourcing_process_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>
				
				<!--委外单编号-->
				<template v-if="auth('m_outsourcing_order')" #outsourcing_code="{data}">
					<c-link @click="globalDialog('outSourcingDetail', {props: {id: data.out_sourcing_order_id}})">{{data.outsourcing_code}}</c-link>
				</template>
				
				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>

				<!--动态类型-->
				<template #progress_type="{data}">
					<c-state dict="outSourcingOrderProcessName" tag :value="data.progress_type"></c-state>
				</template>

				<!--附件-->
				<template #attachment_file_url="{data}">
                    <c-file v-if="data.attachment_file_url" :src="data.attachment_file_url" media style="width: 32px; height: 32px;"></c-file>
                </template>

				<!--创建人类型-->
				<template #create_user_type="{data}">
					<c-state dict="outSourcingOrderProcessCreateUserType" tag :value="data.create_user_type"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					button-limit="1"
					width="60"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_outsourcing_process_print')" v-lock="lock('b_outsourcing_process_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateDic','priorityDic','outSourcingOrderProcessName']),
		},
		
		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*******搜索【供应商】下拉框信息*****************/
			searchSupplier(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SUPPLIER',
						keyword: keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>